/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';

interface IAccountProfileDescription {
    className: string;
    description: string;
}

const IAccountProfileDescription: React.FC<IAccountProfileDescription> = ({ className, description }) => (
    <p className={className}>
        {description}
    </p>
);

export default IAccountProfileDescription;
